import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { ref: "widget" }
const _hoisted_2 = { class: "CheckYourFitText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      ref: "widget",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args))),
      class: "ButtonTextWidget js-Widget"
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "lnr-clipboard-check" }, null, -1 /* HOISTED */)),
      _createElementVNode("span", _hoisted_2, [
        (_ctx.isEmptyProfile)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Check your fit ")
            ], 64 /* STABLE_FRAGMENT */))
          : (_ctx.isFillingProfile)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Continue to check your fit ")
              ], 64 /* STABLE_FRAGMENT */))
            : (!_ctx.userLoggedIn && !_ctx.isFillingProfile)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(" Log in to check your fit ")
                ], 64 /* STABLE_FRAGMENT */))
              : (_ctx.isFullProfile)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(_ctx.displayScore), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
      ])
    ], 512 /* NEED_PATCH */)
  ], 512 /* NEED_PATCH */))
}